<div class="topbar-user-block">

  <!-- User pill: avatar + nome + tipo de empresa -->
  <div class="user-pill">
    <div class="user-avatar">{{ userInitials }}</div>
    <div class="user-meta">
      <span class="user-name">{{ globalVar.UserName }}</span>
      <span class="user-company">{{ globalVar.CompanyTypeDescription }}</span>
    </div>
  </div>

  <!-- Sair -->
  <button class="sair-btn" (click)="logout()">Sair</button>

</div>
